import { useQuery } from '@tanstack/react-query';
import { ShopifyShippingZone } from '../models/ppoints/ShopifyShippingZone';
import ShippingZoneService from '../services/settings/ppoints/ShippingZoneService';

export const useShippingZones = (ecomId: number | null) => {
    return useQuery<ShopifyShippingZone[]>({
        queryKey: [`shipping-zones`, { ecomId: ecomId }],
        queryFn: () => ShippingZoneService.getShippingZones(ecomId),
        staleTime: 10000,
        cacheTime: 60000,
    });
};
